import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

const fetchBuskingSLA = async (dateTime: string) => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_APIM_BASE_URL}/sla/v1/BuskingAndStreetEntertainmentSla`,
      {
        params: { time: dateTime },
        headers: {
          'Ocp-Apim-Subscription-Key': import.meta.env
            .VITE_APIM_API_KEY as string,
          'Content-Type': 'application/json',
        },
      },
    );

    if (!response.data) {
      throw new Error('Failed to fetch data from server');
    }

    return response.data;
  } catch (error) {
    throw new Error((error as Error).message);
  }
};

export const useBuskingSLA = (dateTime: string) => {
  return useQuery({
    queryKey: ['buskingSLA', dateTime],
    queryFn: () => fetchBuskingSLA(dateTime),
    enabled: Boolean(dateTime),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
